import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Site } from '@classes/site';
import { HolidayGroup } from './holiday-group';

export class Schedule extends BaseClass{
    site: Site;
    startDayTime: string;
    endDayTime: string;
    days?: Number[];
    holidayGroup?: HolidayGroup;

    constructor()
    constructor(
      site: Site,
      startDayTime: string,
      endDayTime: string,
      days?: Number[],
      holidayGroup?: HolidayGroup
      )
    constructor(
      site?: Site,
      startDayTime?: string,
      endDayTime?: string,
      days?: Number[],
      holidayGroup?: HolidayGroup
      ) {
        super();
        this.site = site
        this.startDayTime = startDayTime;
        this.endDayTime = endDayTime;
        this.days = days;
        this.holidayGroup = holidayGroup;
    }

    static fromObject(object: Schedule): Schedule {
      return Object.assign(new Schedule(), {
        ...object,
        holidayGroup: object.holidayGroup ? HolidayGroup.fromObject(object.holidayGroup) : null,
        site: object.site ? Site.fromObject(object.site) : null
      });
  }
}
